export default {
  SET_BLOGS: "SET_BLOGS",
  SET_TOPICS: "SET_TOPICS",
  SET_POPULAR_PRODUCTS: "SET_POPULAR_PRODUCTS",
  SET_BLOG: "SET_BLOG"
};
